export const formatDate = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const paddedMonth = month < 10 ? '0' + month : month;
    const day = date.getDate();
    const paddedDay = day < 10 ? '0' + day : day;
    return `${String(year).padStart(4, '0')}-${paddedMonth}-${paddedDay}`;
};
